import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const createBatch = createAsyncThunk<void, CreateBatchBody, { extra: Partial<Dependencies> }>(
  "batches/createBatch",
  async (batch: CreateBatchBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.createBatch(batch);
  },
);

export const resetCreateBatch = createAction("batches/resetCreateBatch");
